export default __webpack_public_path__ + "static/media/fontawesome-webfont3e6e.20fd1704.woff2";